import React from 'react';
import { Button } from '@fluentui/react-components';
import { ArrowClockwise16Filled } from '@fluentui/react-icons';
import localizations from '@widgets/localization/localizations.json';
import { devComponentName } from '@morning-dashboard/helpers/isDevEnv';

export type RetryBtnProps = {
  onRetry: () => void;
};

const RetryBtn: React.FC<RetryBtnProps> = ({ onRetry }) => {
  return (
    <Button
      {...devComponentName('RetryBtn')}
      as="button"
      appearance="primary"
      icon={<ArrowClockwise16Filled />}
      onClick={onRetry}
    >
      {localizations.retryBtn.label}
    </Button>
  );
};

export default RetryBtn;
